export default __webpack_public_path__ + "static/media/PROCESSMETHOD_PRINTING_FDM.db42334d.png";